import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const state = {
  data: {},
}

const actions = {
  getData({commit}) {
    console.log('getData')
    axios.get('http://www.cdtfxqzl.cn/bigdata/bigdata.json').then(res => {
      console.log(res)
    })
  }
}

export default new Vuex.Store({
  state,
  actions
})